module.exports = require("babel-runtime/core-js/promise");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/promise"
// module id = 6
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 17